import { Add16Filled } from "@fluentui/react-icons";
import { BenefitCardOrderSubmit } from "components/BenefitCardOrderSubmit/BenefitCardOrderSubmit";
import { PackageDialog } from "components/PackageDialog/PackageDialog";
import { ActionButton, Flex, ToolbarContainer } from "components/styled";
import { useIsListView } from "hooks/useIsListView";
import { useRoleType } from "hooks/useRoleType";
import { PrimitiveAtom } from "jotai";
import { IBenefitImplementation, IBenefitPackage } from "library/types";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  benefitImplementation: IBenefitImplementation;
  packageList: IBenefitPackage[];
  searchActive: boolean;
  orderedPackagesAtom: PrimitiveAtom<IBenefitPackage[]>;
  searchFilterValue?: string;
};

export function PackagesToolbar({
  benefitImplementation,
  searchActive,
  packageList,
  searchFilterValue,
  orderedPackagesAtom,
}: Props) {
  const { t } = useTranslation();
  const [openAddPackage, setOpenAddPackage] = useState(false);

  const roles = useRoleType();
  const isReadOnlyUser = roles?.hasReadOnlyRole;

  const onDialogOpenChange = useCallback((state) => {
    setOpenAddPackage(state);
  }, []);

  const benefitKey = `${benefitImplementation?.countryCode}-${benefitImplementation.clientInternalNumberGos}-package`;

  return (
    <ToolbarContainer>
      <div />
      <Flex>
        <BenefitCardOrderSubmit
          searchFilterValue={searchFilterValue}
          disabled={searchActive}
          itemList={packageList}
          settingKey={benefitKey}
          orderedAtom={orderedPackagesAtom}
          itemIdProperty="benefitPackageTag"
        />
        <ActionButton
          noBorder
          disabled={isReadOnlyUser}
          appearance="subtle"
          icon={<Add16Filled />}
          onClick={() => {
            setOpenAddPackage(true);
          }}
        >
          {t("hbh.addPackage.label")}
        </ActionButton>
      </Flex>
      {openAddPackage && (
        <PackageDialog
          benefitImplementation={
            benefitImplementation as IBenefitImplementation
          }
          open={openAddPackage}
          setOpen={onDialogOpenChange}
        />
      )}
    </ToolbarContainer>
  );
}
